export default __webpack_public_path__ + "a20125a9178f64a9ce31e02f10ea38fa.svg";